import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
export function NewFeatureBadge() {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.pop-out.badge.introduction"
    }),
    children: /*#__PURE__*/_jsx(Badge, {
      use: "new",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.pop-out.badge.new"
      })
    })
  });
}
NewFeatureBadge.displayName = 'FullscreenComposerButtonFeatureBadge';